import React, { FC } from 'react'
import { PageLayout } from '../System'
import { StyledIssueListView, IssueList, IssueFilters } from '.'

const IssueListView: FC = () => {
  return (
    <PageLayout pageTitle="Issues">
      <StyledIssueListView>
        <IssueFilters />
        <IssueList />
      </StyledIssueListView>
    </PageLayout>
  )
}

export default IssueListView
